import axios from "axios";
const AxiosInstance = axios.create({
  // baseURL: "http://localhost:7878",
  baseURL: "https://unitedairtravels-backend.vercel.app",
  withCredentials: true,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
  },
});

export default AxiosInstance;
